/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EnvSpec } from './EnvSpec';
import {
    EnvSpecFromJSON,
    EnvSpecFromJSONTyped,
    EnvSpecToJSON,
} from './EnvSpec';

/**
 * 
 * @export
 * @interface PhoneHomePayload
 */
export interface PhoneHomePayload {
    /**
     * 
     * @type {string}
     * @memberof PhoneHomePayload
     */
    backendId: string;
    /**
     * 
     * @type {string}
     * @memberof PhoneHomePayload
     */
    reason?: string;
    /**
     * 
     * @type {number}
     * @memberof PhoneHomePayload
     */
    returnCode?: number;
    /**
     * 
     * @type {number}
     * @memberof PhoneHomePayload
     */
    timestampMs?: number;
    /**
     * 
     * @type {number}
     * @memberof PhoneHomePayload
     */
    durationMs?: number;
    /**
     * 
     * @type {string}
     * @memberof PhoneHomePayload
     */
    status: string;
    /**
     * 
     * @type {EnvSpec}
     * @memberof PhoneHomePayload
     */
    envSpec?: EnvSpec;
}

/**
 * Check if a given object implements the PhoneHomePayload interface.
 */
export function instanceOfPhoneHomePayload(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "backendId" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function PhoneHomePayloadFromJSON(json: any): PhoneHomePayload {
    return PhoneHomePayloadFromJSONTyped(json, false);
}

export function PhoneHomePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneHomePayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'backendId': json['backend_id'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'returnCode': !exists(json, 'return_code') ? undefined : json['return_code'],
        'timestampMs': !exists(json, 'timestamp_ms') ? undefined : json['timestamp_ms'],
        'durationMs': !exists(json, 'duration_ms') ? undefined : json['duration_ms'],
        'status': json['status'],
        'envSpec': !exists(json, 'env_spec') ? undefined : EnvSpecFromJSON(json['env_spec']),
    };
}

export function PhoneHomePayloadToJSON(value?: PhoneHomePayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'backend_id': value.backendId,
        'reason': value.reason,
        'return_code': value.returnCode,
        'timestamp_ms': value.timestampMs,
        'duration_ms': value.durationMs,
        'status': value.status,
        'env_spec': EnvSpecToJSON(value.envSpec),
    };
}

